export const setCurrentUUID = (state, payload) => {
  state.currentUUID = payload
}

export const setCurrentGuest = (state, payload) => {
  state.currentGuest = payload
}

export const updateCurrentGuest = (state, payload) => {
  Object.assign(state.currentGuest, payload)
}

export const setCurrentAccountId = (state, payload) => {
  state.currentAccountId = payload
}

export const setCurrentAccount = (state, payload) => {
  state.currentAccount = payload
}

export const setAccessDenied = (state, payload) => {
  state.accessDenied = payload
}

export const updateCurrentAccount = (state, payload) => {
  Object.assign(state.currentAccount, payload)
}

export const setLoaded = (state, payload) => {
  state.loaded = payload
}

export const setStripePublishableKey = (state, payload) => {
  state.stripePublishableKey = payload
}

export const setNoNetworkConnection = (state, payload) => {
  state.noNetworkConnection = payload
}

export const setRetailCartId = (state, payload) => {
  state.retailCartId = payload
}